import chatgptLogo from "@static/img/chatgpt-logo.png";
import claudeLogo from "@static/img/claude-logo.png";
import geminiLogo from "@static/img/gemini-logo.png";

import { getAssetUrl } from "@helpers/helpers";

const ProviderBadge = ({ src, alt }: { src: string; alt: string }) => (
  <div className="h-8 w-8 rounded-full bg-white border border-gray-100 flex items-center justify-center p-1">
    <img src={getAssetUrl(src)} alt={alt} className="h-6 w-6 object-contain" />
  </div>
);

const AiToolsCard = ({ onClick }: { onClick: () => void }) => (
  <button
    type="button"
    onClick={onClick}
    className="block w-full text-left bg-gray-50 rounded-lg border border-gray-200 p-4 hover:bg-gray-100 hover:border-gray-300 hover:shadow-sm"
  >
    <div className="flex items-start justify-between gap-4">
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-gray-900">
          Want to setup your AI tools?
        </div>
        <p className="text-sm text-gray-500 mt-1">
          Connect Topicflow to your AI assistant via MCP to read and update your
          work.
        </p>
      </div>
      <div className="flex shrink-0 -space-x-2">
        <ProviderBadge src={claudeLogo} alt="Claude" />
        <ProviderBadge src={geminiLogo} alt="Gemini" />
        <ProviderBadge src={chatgptLogo} alt="ChatGPT" />
      </div>
    </div>
  </button>
);

export default AiToolsCard;
